define.alias("shared/utils/feature-requirements", "media/utils/feature-requirements");